import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-full-value-popup',
  templateUrl: './full-value-popup.component.html',
  styleUrls: ['./full-value-popup.component.scss'],
})
export class FullValuePopupComponent implements OnInit {
  @Input() value: number | string | undefined;
  @Input() revert: boolean | undefined;
  @Input() noFrame: boolean | undefined;
  constructor() {}

  ngOnInit(): void {}
}
